import { getParameterByName } from '../../utils/toSearchParams';
import { isEmpty } from 'lodash';
import Aside from '../Aside';
import ProductDetailModal from '../Modal/ProductDetail';
import ErrorModal from '../Modal/Error/ErrorModal';
import DigiflexModal from '../Modal/Digiflex/Digiflex';
import SearchImportModal from '../Modal/SearchImport';
import Legende from '../Modal/Legende/Legende';
import FastBookModal from '../Modal/Fastbook';
import AnalogModal from '../Modal/Analog';
import ProductImageModal from '../Modal/ProductImage';
import React, { useEffect } from 'react';
import classNames from 'classnames';
import bsStyles from '../../styles/bs.module.scss';
import { ReactComponent as IconClose } from '../../assets/icons/closeNew.svg';
import Modal from 'react-modal';
import * as _actionsProduct from '../../actions/product';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router';
import MapContainer from '../MapContainer';
import Map from '../../components/MapContainer/index';
import Spinner from '../Spinner';
import './ModalContainer.scss';
import AgencyCampaignModal from '../Modal/AgencyCampaign';
import ConfirmationModal from '../Modal/AbstractConfirmation';
import { PartiallyIntegratedUserDataEC } from '../../reducers/app';
import { SchemaProduct } from '@repo/legacy-commerce-api';

interface Props {
  location: any;
  product: any;
  userDataEC: PartiallyIntegratedUserDataEC;
  productsJ2: SchemaProduct[];
  errors: any;
  loading: { general: boolean; mapProduct?: boolean };
  actionsJourney2: any;
  productsJ2ByUrn: Record<string, SchemaProduct>;
  actionsBasket: any;
  intl: any;
  actionsProduct: typeof _actionsProduct;
  campaignObj?: any;
  confirmationContent?: any;
  confirmationOnSuccess?: any;
  isSuccessButtonLoading?: boolean;
}

export const ModalContainer = (props: Props) => {
  const params = useParams();
  const navigate = useNavigate();
  const modalContent = getParameterByName('modalContent', props.location.search);
  const urn = getParameterByName('urn', props.location.search);

  useEffect(() => {
    if (modalContent === 'map' && urn) {
      props.actionsProduct.fetchProductByUrnWithStateUpdate({ urn: urn });
    }
  }, [props.location.search]);

  const renderModalContent = (modalContent: string) => {
    const {
      location,
      product,
      userDataEC,
      productsJ2,
      errors,
      loading,
      actionsJourney2,
      productsJ2ByUrn,
      actionsBasket,
      intl,
      confirmationContent,
      confirmationOnSuccess,
      isSuccessButtonLoading,
    } = props;

    if (modalContent === 'map') {
      const lat = getParameterByName('lat', location.search);
      const lng = getParameterByName('lng', location.search);
      const urn = getParameterByName('urn', location.search);
      let coordinates = { lat, lng };
      const currentProduct = product && product[urn];
      const name = currentProduct ? product[urn].name : '';
      const address = currentProduct ? product[urn].address : '';
      const subpoints = currentProduct ? product[urn].subpoints : [];
      const area = currentProduct ? product[urn].area : [];
      const state = currentProduct ? product[urn].state : 0;
      const zoomBase = !isEmpty(area) && !isEmpty(subpoints) ? 10 : 15;
      const zoomDigiflex = currentProduct && product[urn].producttype === 'digital' ? 17 : null;
      let zoom = zoomDigiflex ? zoomDigiflex : zoomBase;

      return (
        <div className='mapModal modal'>
          {(props.loading.mapProduct || props.loading.general) && <Spinner />}
          <div
            className={classNames('d-flex justify-content-between mapModalBody', {
              modalLoading: props.loading.mapProduct && props.loading.general,
            })}
            id='mapElement'
          >
            <div className={'pointer ms-auto closeModalIcon'} onClick={() => navigate({ search: '' })}>
              <IconClose />
            </div>

            <Map
              center={coordinates}
              zoom={!isEmpty(area) && !isEmpty(subpoints) ? 10 : 15}
              locations={{
                1: {
                  lngLtd: coordinates,
                  types: ['locality'],
                  name: name,
                  address: address,
                  state,
                  area,
                  subpoints,
                  producturn: 1,
                  product: currentProduct,
                },
              }}
              useCustomMarker
              productUrnStrBasket={userDataEC.basketProducts.products
                .map(({ latitude, longitude }: any) => `${latitude}${longitude}`)
                .join('-')}
              modalMode={true}
              isShowGreenUnavailable={true}
              showingProductInfoWindow={true}
            />
          </div>
        </div>
      );
    } else if (modalContent === 'mapCampaign') {
      const lat = getParameterByName('lat', location.search);
      const lng = getParameterByName('lng', location.search);
      const urn = getParameterByName('urn', location.search);
      let coordinates = { lat, lng };
      // const campaignObj = getCampaignObj();
      let products =
        props.campaignObj && props.campaignObj.products
          ? props.campaignObj.products.filter((product: SchemaProduct) => product.producturn === urn)
          : [];
      const product = products && products.length > 0 ? products[0] : {};
      const { subpoints = [], area = [], state = 0 } = product;

      return (
        <div className='mapModal modal'>
          <div className='d-flex justify-content-between' id='mapElement'>
            <div className={'pointer ms-auto closeModalIcon'} onClick={() => navigate({ search: '' })}>
              <IconClose />
            </div>

            <MapContainer
              center={coordinates}
              zoom={!isEmpty(area) && !isEmpty(subpoints) ? 10 : 15}
              locations={{
                1: {
                  lngLtd: coordinates,
                  types: ['locality'],
                  state,
                  area,
                  subpoints,
                  producturn: 1,
                },
              }}
              useCustomMarker
              productUrnStrBasket={
                props.userDataEC.chosenBasketProducts &&
                props.userDataEC.chosenBasketProducts.products &&
                props.userDataEC.chosenBasketProducts.products
                  .filter((item: SchemaProduct) => Number(item.state) === 0)
                  .map(({ latitude, longitude }: any) => `${latitude}${longitude}`)
                  .join('-')
              }
              modalMode
            />
          </div>
        </div>
      );
    } else if (modalContent === 'faq') {
      return <Aside modal step={params.step} />;
    } else if (modalContent === 'product') {
      const urn = getParameterByName('urn', location.search);
      const currentProduct = product && product[urn];
      return (
        <ProductDetailModal
          intl={intl}
          location={location}
          totalNumber={productsJ2?.length}
          product={currentProduct}
          userDataEC={userDataEC}
          loading={loading}
          journey2
          productNew={userDataEC?.basketProducts?.productsByUrn[urn]}
          actionsJourney2={actionsJourney2}
          actionsBasket={actionsBasket}
          productsJ2ByUrn={productsJ2ByUrn}
          errors={errors}
        />
      );
    } else if (modalContent === 'error') {
      return <ErrorModal intl={intl} location={location} />;
    } else if (modalContent === 'digiflex') {
      return <DigiflexModal intl={intl} location={location} />;
    } else if (modalContent === 'import') {
      return <SearchImportModal intl={intl} />;
    } else if (modalContent === 'legende') {
      return <Legende />;
    } else if (modalContent === 'fastbook') {
      return <FastBookModal />;
    } else if (modalContent === 'analog') {
      return <AnalogModal intl={intl} location={location} />;
    } else if (modalContent === 'productImage') {
      return <ProductImageModal intl={intl} location={location} />;
    } else if (modalContent === 'confirmation') {
      return (
        <ConfirmationModal
          intl={intl}
          content={confirmationContent}
          onSuccess={confirmationOnSuccess}
          onClose={() => {
            navigate({ search: '' });
          }}
          isSuccessButtonLoading={isSuccessButtonLoading}
        />
      );
    } else if (modalContent === 'editCampaign' && userDataEC.isAgencyJourney) {
      return (
        <AgencyCampaignModal
          isEditModal={true}
          userDataEC={props.userDataEC}
          onClose={() => {
            navigate({ search: '' });
          }}
          onSuccess={() => {
            navigate({ search: '' });
          }}
        />
      );
    }
  };

  return (
    <Modal
      isOpen={Boolean(modalContent)}
      onRequestClose={() => {
        if (modalContent === 'digiflex') {
          props.actionsProduct.clearDigiflexData();
        }
        navigate({ search: '' });
      }}
      className={'large-modal'}
      shouldCloseOnOverlayClick={true}
      closeTimeoutMS={0}
      overlayClassName={'overlay'}
    >
      <div
        className={classNames('background-light-grey modal', bsStyles.bootstrap, {
          'medium-modal': modalContent === 'digiflex' || modalContent === 'fastbook' || modalContent === 'analog',

          'extra-medium-modal':
            modalContent === 'import' ||
            modalContent === 'product' ||
            modalContent === 'productImage' ||
            modalContent === 'confirmation' ||
            modalContent === 'editCampaign',
        })}
      >
        {modalContent && renderModalContent(modalContent)}
      </div>
    </Modal>
  );
};
